var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondeeIconOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.768 10.205c-.425.715-.576 1.604-.304 2.36.278.774.942 1.41 1.716 1.751.782.346 1.571.35 2.11.026.453-.273.953-.576 1.48-.899a615.249 615.249 0 016.995-4.37.829.829 0 00-.166-.016H9.412c-.58 0-1.213.422-1.644 1.148zm5.556 4.126a789.448 789.448 0 007.046-4.388 3218.923 3218.923 0 00-4.262 8.85c-.275.569-.938 1-1.78 1.142-.834.14-1.737-.025-2.397-.52-.644-.482-1.006-1.305-1.043-2.132-.038-.84.26-1.54.745-1.86.454-.3 1.035-.674 1.69-1.092zm-3.168 1.29a3.712 3.712 0 00-.314 1.709c.048 1.07.516 2.215 1.461 2.923.929.696 2.135.893 3.2.714 1.055-.178 2.08-.749 2.548-1.72.829-1.73 2.3-4.779 3.278-6.806l.982-2.036v-.002c.232-.505.113-1.108-.174-1.552a1.809 1.809 0 00-1.538-.84H9.412c-1.08 0-2.002.748-2.544 1.66-.548.921-.788 2.136-.39 3.247.393 1.091 1.292 1.92 2.28 2.356.44.195.92.32 1.398.347z",
    fill: "#E74"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 27.5,
    rx: 3.75,
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })));
}
export default SvgFondeeIconOrange;